/**
 * «بعد از ورود، برگرد همین‌جا» — `state`ِ هر لینک یا ناوبری به `/auth` که
 * روی خودِ صفحه زده می‌شود (WHOSUP-359). `AuthRoute` در routes.tsx می‌خواندش.
 *
 * دو چیز می‌گوید:
 *   • `from` — آدرسِ همین صفحه، تا بعد از ورود همین‌جا برسیم نه صفحه‌ی اول.
 *     دکمه‌ی «ورود» در هدر و منوی گوشی و کارتِ «تو هم عضو شو» تا امروز
 *     چیزی نمی‌فرستادند؛ کسی که از صفحه‌ی یک رویداد وارد می‌شد سر از کشف
 *     درمی‌آورد.
 *   • `back` — «صفحه‌ی ورود روی همین صفحه باز شد»، یعنی همین صفحه درست زیرِ
 *     آن در تاریخچه‌ی مرورگر است. بعد از ورود به عقب برمی‌گردیم به‌جای اینکه
 *     یک نسخه‌ی دیگر از همان صفحه جای «ورود» بنشیند — وگرنه دکمه‌ی برگشتِ
 *     مرورگر اول همان صفحه را دوباره نشان می‌داد.
 *
 * ⚠ `back` فقط مالِ این‌جاست، نه مالِ لینک‌هایی که `from`شان **مقصد** است
 * (تبِ «دوستان» برای مهمان، دکمه‌ی «برنامه‌ی جدید» در هدر، و `Private`): آن‌ها
 * جایی می‌روند که کاربر هنوز در آن نبوده، پس چیزی زیرِ «ورود» نیست که به آن
 * برگردیم.
 */
export interface AuthReturn {
  from: string;
  back?: true;
}

export function returnHere(location: { pathname: string; search: string; state: unknown }): AuthReturn | undefined {
  // روی خودِ صفحه‌ی ورود (هدر آن‌جا هم هست): همان مقصدی که با آن آمده بود
  // سرِ جایش بماند، نه اینکه «ورود» مقصدِ خودش شود.
  if (location.pathname === '/auth') return (location.state as AuthReturn | null) ?? undefined;
  return { from: location.pathname + location.search, back: true };
}
